import callAPiBase from './base';

const fareBonusApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareBonusList',
      method: 'GET',
      useToken: true,
      title: 'Fare Bonus - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareBonusCreate',
      method: 'POST',
      useToken: true,
      title: 'Fare Bonus - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareBonusUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Fare Bonus - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareBonusDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Fare Bonus - Delete',
      params,
    }),
};

export { fareBonusApi };
export default fareBonusApi;
